import leadsApi from '@/api/leads.js';
import type {
    CommunicatingLead,
    CommunicatingUser,
    RecentCommunication,
} from '@/entities/lead/useLeadCommunicating.ts';

export type CheckCommunicatingResponse =
    | {
          isCommunicating: true;
          lead: CommunicatingLead;
      }
    | {
          isCommunicating: false;
          lead?: undefined;
      };

type RawSetCommunicatingResponse = {
    user: CommunicatingUser | false;
    communication: RecentCommunication | false;
    type: number | null;
};

export type SetCommunicatingResult =
    | {
          kind: SetCommunicatingResultKind.CONFLICT;
          communicatingLead: CommunicatingLead;
      }
    | {
          kind: SetCommunicatingResultKind.RECENT_COMMUNICATION;
          communication: RecentCommunication;
      }
    | {
          kind: SetCommunicatingResultKind.CLAIMED;
      };

type SetCommunicatingPayload = {
    type: number;
};

export enum SetCommunicatingResultKind {
    CONFLICT = 'conflict',
    RECENT_COMMUNICATION = 'recent-communication',
    CLAIMED = 'claimed',
}

const toCommunicatingLead = (
    leadId: number,
    user: CommunicatingUser,
    communicationMethodId: number | null
): CommunicatingLead => ({
    id: leadId,
    communication_method_id: communicationMethodId,
    communicating_user: user,
});

export const leadCommunicatingApi = {
    async checkCommunicating(leadId: number): Promise<CheckCommunicatingResponse> {
        return leadsApi.checkCommunicating(leadId) as Promise<CheckCommunicatingResponse>;
    },

    async setCommunicating(
        leadId: number,
        payload: SetCommunicatingPayload
    ): Promise<SetCommunicatingResult> {
        const response = await leadsApi.setCommunicating({ id: leadId }, payload);
        const data = response.data.data as RawSetCommunicatingResponse;

        if (data.user) {
            return {
                kind: SetCommunicatingResultKind.CONFLICT,
                communicatingLead: toCommunicatingLead(leadId, data.user, data.type),
            };
        }

        if (data.communication) {
            return {
                kind: SetCommunicatingResultKind.RECENT_COMMUNICATION,
                communication: data.communication,
            };
        }

        return {
            kind: SetCommunicatingResultKind.CLAIMED,
        };
    },

    async removeCommunicating(leadId: number): Promise<void> {
        await leadsApi.removeCommunicating({ id: leadId });
    },
};
